import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appScroll]'
})
export class ScrollDirective {
  element: ElementRef;
  @Output() cambiarScroll = new EventEmitter();

  constructor(elemento: ElementRef) {
    this.element = elemento;
  }

  @HostListener('scroll', ['$event'])
  scrolling($event: any) {
    let num = $event.srcElement.scrollTop;
    if (num > 100) {
      this.cambiarScroll.emit(true);
    } else {
      this.cambiarScroll.emit(false);
    }
  }

  ngOnInit() {
  }

}
